export const Intent = {
  PRIMARY: 'PRIMARY' as const,
  SECONDARY: 'SECONDARY' as const,
  ERROR: 'ERROR' as const,
  SUCCESS: 'SUCCESS' as const,
  WARNING: 'WARNING' as const,
  INFO: 'INFO' as const,
  MUTED: 'MUTED' as const,
};

export type Intent = typeof Intent[keyof typeof Intent];

export const getTailwindColorClass = (intent: Intent | undefined | null) => {
  switch (intent) {
    case Intent.PRIMARY: return 'primary';
    case Intent.SECONDARY: return 'gray';
    case Intent.ERROR: return 'error';
    case Intent.SUCCESS: return 'success';
    case Intent.INFO: return 'info';
    case Intent.WARNING: return 'warning';
    case Intent.MUTED: return 'gray';
    default: return 'primary'
  }
}